import { basePath } from "../common/path";

const path = {
  getAllActivities: basePath.concat("/iper"),
  createActivity: basePath.concat("/iper/activities"),
  editActivity: basePath.concat("/iper/activities"),
  getDangers: basePath.concat("/iper/dangers"),
  getRisksByDanger: basePath.concat("/iper/dangers"),
  getKinney: basePath.concat("/iper/kinney-method"),
  getAreaDetail: basePath.concat("/iper/area"),
  saveIper: basePath.concat("/iper"),
  savePhoto: basePath.concat("/iper"),
  updateIper: basePath.concat("/iper"),
  getIper: basePath.concat("/iper"),
  getAreaActivities: basePath.concat("/iper/areas"),
  getHistoryIper: basePath.concat("/iper"),
  getPositionByArea: "/positions/area",
  getEmployees: "/employees"
};
export { path };